<template>
  <div class="d2-multiple-page-control-group" flex>
    <div class="d2-multiple-page-control-content" flex-box="1">
      <div class="d2-multiple-page-control-content-inner">
        <d2-contextmenu
          :visible.sync="contextmenuFlag"
          :x="contentmenuX"
          :y="contentmenuY"
        >
          <d2-contextmenu-list
            :menulist="
              tagName === '/index' ? contextmenuListIndex : contextmenuList
            "
            @rowClick="contextmenuClick"
          />
        </d2-contextmenu>
        <div class="d-flex">
          <div class="tabs-tool">
            <div class="tabs-tool__item" @click="handleToggleAside">
              <a>
                <i
                  :class="asideCollapse ? `el-icon-s-unfold` : `el-icon-s-fold`"
                ></i>
              </a>
            </div>
          </div>

          <el-tabs
            class="d2-multiple-page-control d2-multiple-page-sort"
            style="background-color: #f7f7f8;flex: 1;"
            :value="current"
            type="card"
            @tab-click="handleClick"
            @tab-remove="handleTabRemove"
            @contextmenu.native="handleContextmenu"
          >
            <el-tab-pane
              v-for="page in opened"
              :key="page.fullPath"
              :label="pageTitle(page) || '未命名'"
              :name="page.fullPath"
              :closable="isTabClosable(page)"
            />
          </el-tabs>

          <div class="tabs-tool">
            <el-dropdown
              class="d-flex"
              size="default"
              @click="closeAll"
              @command="(command) => handleControlItemClick(command)"
            >
              <span class="tabs-tool__item">
                <i class="el-icon-menu el-icon--center"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="refresh">
                  <i class="fa fa-refresh" aria-hidden="true"></i>
                  刷新
                </el-dropdown-item>
                <el-dropdown-item command="left">
                  <i class="fa fa-arrow-left" aria-hidden="true"></i>
                  关闭左侧
                </el-dropdown-item>
                <el-dropdown-item command="right">
                  <i class="fa fa-arrow-right" aria-hidden="true"></i>
                  关闭右侧
                </el-dropdown-item>
                <el-dropdown-item command="other">
                  <i class="fa fa-times" aria-hidden="true"></i>
                  关闭其它
                </el-dropdown-item>
                <el-dropdown-item command="all">
                  <i class="fa fa-times-circle" aria-hidden="true"></i>
                  全部关闭
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <div class="tabs-tool__item">
              <headerUploader />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Sortable from 'sortablejs'
import headerUploader from '../header-uploader'

export default {
  components: {
    D2Contextmenu: () => import('../contextmenu'),
    D2ContextmenuList: () =>
      import('../contextmenu/components/contentmenuList'),
    headerUploader,
  },
  data() {
    return {
      contextmenuFlag: false,
      contentmenuX: 0,
      contentmenuY: 0,
      contextmenuListIndex: [
        { icon: 'times-circle', title: '关闭全部', value: 'all' },
      ],
      contextmenuList: [
        { icon: 'refresh', title: '刷新', value: 'refresh' },
        { icon: 'arrow-left', title: '关闭左侧', value: 'left' },
        { icon: 'arrow-right', title: '关闭右侧', value: 'right' },
        { icon: 'times', title: '关闭其它', value: 'other' },
        { icon: 'times-circle', title: '关闭全部', value: 'all' },
      ],
      tagName: '/index',
    }
  },
  computed: {
    ...mapState('admin/page', ['opened', 'current']),
    ...mapState('admin/menu', ['menuMap', 'asideCollapse']),
    routeMeta() {
      return this.$route.meta
    },
  },
  methods: {
    ...mapActions('admin/page', [
      'close',
      'closeLeft',
      'closeRight',
      'closeOther',
      'closeAll',
      'openedSort',
    ]),
    ...mapActions('admin/menu', ['asideCollapseToggle']),
    pageTitle(page) {
      let { funcID, title = '' } = page.meta || {}
      const menu = this.menuMap[funcID] || {}
      title = typeof title === 'function' ? title({ $route: page, menu }) : title
      return title ? title : menu.title
    },
    /**
     * @description 计算某个标签页是否可关闭
     * @param {Object} page 其中一个标签页
     */
    isTabClosable(page) {
      return page.name !== 'index'
    },
    /**
     * @description 右键菜单功能点击
     * @param {Object} event 事件
     */
    handleContextmenu(event) {
      let target = event.target
      // fix https://github.com/d2-projects/d2-admin/issues/54
      let flag = false
      if (target.className.indexOf('el-tabs__item') > -1) flag = true
      else if (target.parentNode.className.indexOf('el-tabs__item') > -1) {
        target = target.parentNode
        flag = true
      }
      if (flag) {
        event.preventDefault()
        event.stopPropagation()
        this.contentmenuX = event.clientX
        this.contentmenuY = event.clientY
        this.tagName = target.getAttribute('aria-controls').slice(5)
        this.contextmenuFlag = true
      }
    },
    /**
     * @description 右键菜单的 row-click 事件
     * @param {String} command 事件类型
     */
    contextmenuClick(command) {
      this.handleControlItemClick(command, this.tagName)
    },
    /**
     * @description 接收点击关闭控制上选项的事件
     * @param {String} command 事件类型
     * @param {String} tagName tab 名称
     */
    handleControlItemClick(command, tagName = null) {
      if (tagName) this.contextmenuFlag = false
      const params = { pageSelect: tagName }
      switch (command) {
        case 'refresh':
          location.reload()
          break
        case 'left':
          this.closeLeft(params)
          break
        case 'right':
          this.closeRight(params)
          break
        case 'other':
          this.closeOther(params)
          break
        case 'all':
          this.closeAll()
          break
        default:
          this.$message.error('无效的操作')
          break
      }
    },
    /**
     * @description 接收点击 tab 标签的事件
     * @param {object} tab 标签
     * @param {object} event 事件
     */
    handleClick(tab) {
      // 找到点击的页面在 tag 列表里是哪个
      const page = this.opened.find((page) => page.fullPath === tab.name)
      if (page) {
        const { name, params, query } = page
        this.$router.push({ name, params, query })
      }
    },
    /**
     * @description 点击 tab 上的删除按钮触发这里
     * @param {String} tagName tab 名称
     */
    handleTabRemove(tagName) {
      this.close({ tagName })
    },
    handleToggleAside() {
      this.asideCollapseToggle()
    },
  },
  mounted() {
    const el = document.querySelectorAll(
      '.d2-multiple-page-sort .el-tabs__nav'
    )[0]
    Sortable.create(el, {
      onEnd: (evt) => {
        const { oldIndex, newIndex } = evt
        this.openedSort({ oldIndex, newIndex })
      },
    })
  },
}
</script>
<style lang="scss">
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #fff;
  background-color: #ffffff;
}
.el-tabs__item {
  font-weight: 400 !important;
  color: #4f4f4f !important;
  font-family: 'Muli', sans-serif;
}
.el-tabs__item.is-active {
  font-size: 15px;
  font-weight: 500 !important;
  color: #165cd6 !important;
  font-family: 'Muli', sans-serif;
}

.el-button--default {
  border-radius: 0px !important;
}
</style>
